<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-02-08 09:38:40
 * @LastEditors: shenlin
 * @LastEditTime: 2022-02-24 14:36:57
-->
<template>
  <div class="mapCenter">
    <div id="mapContainer" class="map"></div>
    <leftDate :arrList="leftArr" />
    <rightDate :arrList="rightArr" />
    <indexList />
  </div>
</template>

<script>
import * as echarts from 'echarts'
import JSON from '/static/map/丽水市.json'
import leftDate from './leftdata.vue'
import rightDate from './rightdata.vue'
import indexList from '../left/indexs'
import { initYxjcAmap, rendCityName } from '@/common/map/map.js'
export default {
  name: 'Cockpit',
  computed: {},
  components: { leftDate, rightDate, indexList },
  data() {
    return {
      newPolygons: [],
      areaList: [
        '莲都区',
        '青田县',
        '缙云县',
        '遂昌县',
        '松阳县',
        '云和县',
        '庆元县',
        '景宁畲族自治县',
        '龙泉市'
      ],
      newTown: '',
      leftArr: [53004, 1056, 91],
      rightArr: [273, 158, 11924],
      id: 'mapContainer',
      echartObj: null,
      // radioList: {
      //   A: '农村人口',
      //   B: '城镇人口'
      // },
      radioActive: 'A',
      option: {
        // 地理坐标系组件
        geo: {
          map: '丽水',
          zoom: 1.2,
          aspectScale: 1,
          layoutSize: '100%',
          // layoutCenter: ['50%', '50%'],
          label: {
            show: false
          },

          itemStyle: {
            areaColor: 'rgba(4,73,128, 1)',

            // 设置外层边框
            borderWidth: 2,
            borderColor: '#34B0FF',
            shadowColor: '#34B0FF', // #044B4D
            shadowOffsetY: 7,
            shadowOffsetX: 7,
            shadowBlur: 6
          }
        },

        series: [
          {
            // 图表类型为地图
            type: 'map',
            aspectScale: 1,
            // 使用 registerMap 注册的地图名称
            mapType: '丽水',

            // 地图缩放比例
            zoom: 1.2,
            // 标签的样式
            label: {
              // 标签在默认状态下的样式
              normal: {
                show: true,
                color: '#fff',
                fontSize: 12
              },

              // 标签在高亮状态下的样式
              emphasis: {
                show: true,
                color: '#fff'
              }
            },

            // 选中状态下的样式
            select: {
              // 标签在选中状态下的样式
              label: {
                show: true,
                color: '#fff'
              },

              // 选中状态下地图上区域块的样式
              itemStyle: {
                areaColor: 'rgba(34,216,255, 0.65)'
              }
            },

            // 地图上区域块的样式
            itemStyle: {
              // 默认状态下地图的颜色
              normal: {
                areaColor: '#083288',
                borderColor: 'rgba(0, 210, 255, 1)', // #00d2ff
                borderWidth: 2,
                color: '#fff'
              },

              // 选中状态下地图的颜色
              emphasis: {
                areaColor: 'rgba(0, 210, 255, 0.65)'
              }
            },

            data: []
          }
        ]
      }
    }
  },
  watch: {
    newTown(val, old) {
      if (val !== old) {
        switch (val) {
          case '':
            this.leftArr = [53004, 1056, 91]
            this.rightArr = [273, 158, 11924]
            break
          case '莲都区':
            this.leftArr = [9301, 89, '']
            this.rightArr = ['', '', '']
            break
          case '青田县':
            this.leftArr = [9301, 89, '']
            this.rightArr = ['', '', '']
            break
          case '缙云县':
            this.leftArr = [8266, 100, '']
            this.rightArr = ['', '', '']
            break
          case '遂昌县':
            this.leftArr = [4096, 227, '']
            this.rightArr = ['', '', '']
            break
          case '松阳县':
            this.leftArr = [3081, 62, '']
            this.rightArr = ['', '', '']
            break
          case '云和县':
            this.leftArr = [3500, 70, '']
            this.rightArr = ['', '', '']
            break
          case '庆元县':
            this.leftArr = [4489, 113, '']
            this.rightArr = ['', '', '']
            break
          case '景宁畲族自治县':
            this.leftArr = [2907, 119, '']
            this.rightArr = ['', '', '']
            break
          case '龙泉市':
            this.leftArr = [5829, 105, '']
            this.rightArr = ['', '', '']
            break
        }
        // this.leftArr = [
        //   Math.floor(Math.random() * 10000 + 1),
        //   Math.floor(Math.random() * 10000 + 1),
        //   Math.floor(Math.random() * 100 + 1)
        // ]
        // this.rightArr = [
        //   Math.floor(Math.random() * 100 + 1),
        //   Math.floor(Math.random() * 100 + 1),
        //   Math.floor(Math.random() * 10000 + 1)
        // ]
      }
    }
  },
  created() {},
  mounted() {
    const _that = this
    // 初始化并渲染
    this.echartObj = echarts.init(document.getElementById(this.id))
    echarts.registerMap('丽水', JSON)
    this.echartObj.setOption(_that.option, true)
    this.echartObj.dispatchAction({
      type: 'highlight',
      seriesIndex: 1,
      dataIndex: 3
    })
    // 左上角的按钮点击事件
    this.echartObj.on('click', function(e) {
      console.log(e)
      _that.newTown = e.name == _that.newTown ? '' : e.name
      // e.color = '#d50000'
      // _that.option.geo[1].itemStyle.areaColor = '#d50000'
      // console.log(_that.option.geo[1].itemStyle)
      // e.event.target.style.fill = '#d50000'
    })

    // 监听浏览器大小变化重渲染组件
    window.addEventListener('resize', () => {
      if (this.echartObj && this.echartObj.resize) {
        this.echartObj.resize()
      }
    })
    // this.initMap()
  },
  methods: {
    // getOptions() {
    //   this.setOptions('series')
    //   return this.option
    // },
    // setOptions 设置option里面的配置信息
    // setOptions(objKey, objVal) {
    //   if (
    //     this.option[objKey] &&
    //     typeof this.option[objKey] === 'object' &&
    //     !Array.isArray(this.option[objKey])
    //   ) {
    //     this.option[objKey] = Object.assign(this.option[objKey], objVal)
    //   } else {
    //     this.option[objKey] = objVal
    //   }
    //   this.$set(this.option, objKey, this.option[objKey])
    // }
  },
  /**
   * @description 初始化地图
   */
  initMap() {
    // 渲染地图
    this.map = initYxjcAmap('mapContainer')
    for (let i = 0; i < this.areaList.length; i++) {
      this.areaBG(this.map, this.areaList[i])
    }
    this.addShow()
    this.initEvent()
  },
  // 加载行政区域
  areaBG(map, cityName) {
    let _that = this
    AMap.service('AMap.DistrictSearch', function() {
      let opts = {
        subdistrict: 1, // 返回下一级行政区
        extensions: 'all', // 返回行政区边界坐标组等具体信息
        level: 'district' // 查询行政级别为市
      }
      // 实例化DistrictSearch
      let district = new AMap.DistrictSearch(opts)
      district.setLevel('district')
      // 行政区查询
      district.search(`${cityName}`, function(status, result) {
        rendCityName('white', result.districtList[0])
        // 获取边界信息
        let bounds = result.districtList[0].boundaries
        let polygons = []
        if (bounds) {
          // // 创建图片图层
          // const imageLayer = new AMap.ImageLayer({
          //   bounds: bounds,
          //   url: '../../../../../assets/images/mapMaterial.png', // 图片 Url
          //   zIndex: 22,
          //   zooms: [3, 18] // 设置可见级别，[最小级别，最大级别]
          // })
          // map.add(imageLayer)
          for (let i = 0, l = bounds.length; i < l; i++) {
            // 生成行政区划polygon
            let polygon = new AMap.Polygon({
              map: map,
              strokeWeight: 2,
              path: bounds[i],
              fillOpacity: 0,
              strokeStyle: 'dashed',
              fillColor: '#2B9DFF',
              strokeColor: 'white',
              zIndex: 10,
              extData: {
                town: result.districtList[0].name
              }
            })
            polygons.push(polygon)
            _that.newPolygons.push(polygon)
            map.add(polygons)
            /** 区域点击事件 */
            polygon.on('click', function(e) {
              console.log(polygons)
              _that.newPolygons.forEach(cu => {
                cu.setOptions({
                  fillOpacity: 0,
                  fillColor: '#2B9DFF'
                })
              })
              _that.newTown =
                _that.newTown === polygon.getExtData().town
                  ? ''
                  : polygon.getExtData().town
              // 高亮当前区域
              if (_that.newTown) {
                polygon.setOptions({
                  fillOpacity: 0.7,
                  fillColor: '#49FFEF'
                })
              } else {
                polygon.setOptions({
                  fillOpacity: 0,
                  fillColor: '#2B9DFF'
                })
              }
            })
            /** 区域移入 */
            polygon.on('mousemove', function(e) {
              if (!_that.newTown) {
                _that.newPolygons.forEach(cu => {
                  cu.setOptions({
                    fillOpacity: 0,
                    fillColor: '#2B9DFF'
                  })
                })
                // 高亮当前区域
                polygon.setOptions({
                  fillOpacity: 0.7,
                  fillColor: '#49FFEF'
                })
              }
            })
            /** 区域移除 */
            polygon.on('mouseout', function(e) {
              if (!_that.newTown) {
                _that.newPolygons.forEach(cu => {
                  cu.setOptions({
                    fillOpacity: 0,
                    fillColor: '#2B9DFF'
                  })
                })
                // // 高亮当前区域
                // polygon.setOptions({
                //   fillOpacity: 0.7,
                //   fillColor: '#49FFEF'
                // })
              }
            })
          }
        }
      })
    })
  },
  // 除了丽水市增加遮罩层
  addShow() {
    const that = this
    AMap.plugin('AMap.DistrictSearch', function() {
      new AMap.DistrictSearch({
        extensions: 'all',
        subdistrict: 0
      }).search('丽水市', function(status, result) {
        // 外多边形坐标数组和内多边形坐标数组
        let outer = [
          new AMap.LngLat(-360, 90, true),
          new AMap.LngLat(-360, -90, true),
          new AMap.LngLat(360, -90, true),
          new AMap.LngLat(360, 90, true)
        ]
        let holes = result.districtList[0].boundaries
        let pathArray = [outer]
        pathArray.push.apply(pathArray, holes)
        let polygon = new AMap.Polygon({
          pathL: pathArray,
          strokeColor: '#04082b',
          strokeWeight: 1,
          strokeOpacity: 0,
          fillColor: '#010308',
          fillOpacity: 0.6
        })
        polygon.setPath(pathArray)
        that.map.add(polygon)
        /** 区域点击事件 */
        polygon.on('click', function(e) {
          that.newPolygons.forEach(cu => {
            that.newTown = ''
            cu.setOptions({
              fillOpacity: 0,
              fillColor: '#2B9DFF'
            })
          })
        })
      })
    })
  },
  // 绑定地图点击事件
  initEvent() {
    const that = this
    // 点击地图时收起面板
    this.map.on('click', function(e) {
      // that.clearAllCSS()
      that.newTown = ''
    })
  },
  // 清除高亮样式
  clearAllCSS() {
    // console.log(this.polygons)
    this.polygons.map(cu => {
      cu.setOptions({
        fillOpacity: 0.8,
        fillColor: '#2B9DFF',
        strokeColor: '#49FFEF',
        strokeOpacity: 1,
        strokeWeight: 2
      })
    })
    if (this.polyline) {
      this.polyline.setOptions({
        strokeColor: '#49FFEF'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mapCenter {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 78;
  background: url('~@/assets/images/mapBackground.png') no-repeat;
  background-size: 100% 100%;
  #mapContainer {
    width: 45%;
    height: 55%;
    margin: 1.2rem 0 1.2rem 1rem;
    z-index: 0;
    /deep/ .amap-copyright {
      opacity: 0 !important;
    }
  }
}
</style>
